import React from "react";
import { Switch, Route } from "react-router-dom";
import Innskraning from "pages/innskraning/Innskraning";
import Villa from "pages/innskraning/Villa";


const AuthLayout = props => {
  return (
    <div>
      <Switch>
        <Route exact path="/innskraning" component={Innskraning} />
        <Route exact path="/innskraning/villa" component={Villa} />
      </Switch>
    </div>
  );
};

export default AuthLayout;
